var React      = require('react');
var inflect    = require('inflection').inflect;
var _          = require('lodash');

class AccessControlSearch extends React.Component {

  constructor (props) {
    super(props);
    this.searchSource = new Bloodhound({
      datumTokenizer : Bloodhound.tokenizers.obj.whitespace('value'),
      queryTokenizer : Bloodhound.tokenizers.whitespace,
      remote         : {
        url       : window.location.href.split('?')[0] + '/search?q=%QUERY',
        wildcard  : '%QUERY',
        transform : function (response) {

          var groupResults = response.page_access_groups.map(function (group) {
            return {
              id       : group.id,
              type     : 'group',
              name     : group.name,
              link     : window.location.href.split('#')[0].replace('access-control', 'page-access-groups/') + group.id + '/edit',
              metadata : this.humanizedMetadata(group)
            };
          }.bind(this));

          var userResults = response.page_access_users.map(function (user) {
            return {
              id       : user.id,
              type     : 'user',
              name     : user.email,
              link     : window.location.href.split('#')[0].replace('access-control', 'page-access-users/') + user.id + (props.read_only ? '' : '/edit'),
              metadata : this.humanizedMetadata(user)
            }
          }.bind(this));

          // console.log(groupResults.concat(userResults));
          return groupResults.concat(userResults);
        }.bind(this)
      }
    });
  }

  componentDidMount () {
    $(this.refs.input).typeahead(null, {
      name      : 'access-control',
      display   : 'name',
      source    : this.searchSource,
      templates : {
        suggestion : _.template(
          '<div class="item search-result" data-js-hook="page-access-<%= type %>-<%= id %>" onClick="window.location = \'<%= link %>\'">' +
            '<div class="main">' +
              '<% if (type === "group") { %>' +
              '<i class="fa fa-users"></i>' +
              '<% } else { %>' +
              '<i class="fa fa-user"></i>' +
              '<% } %>' +
              '<span class="name"><%= name %></span>' +
            '</div>' +
            '<div class="secondary small">' +
              '<span><%= metadata %></span>' +
            '</div>' +
          '</div>'
        )
      }
    });
  }

  componentWillUnmount () {
    $(this.refs.input).typeahead('destroy');
  }

  humanizedMetadata (actor) {
    if (actor.group) {
      return 'Belongs to ' + actor.group;
    }
    var list = [];
    _.each(['component', 'metric'], function (field) {
      if (actor[field + 's_list'] === undefined) return;
      var count = actor[field + 's_list'].length;
      if (count > 0) {
        list.push(count + ' ' + inflect(field, count));
      }
    });
    if (list.length > 0) {
      return 'Has access to ' + list.join(' and ');
    } else {
      return 'Has no access to any components or metrics'
    }
  }

  render () {
    return (
      <div className="search-bar" style={{ position : 'relative' }}>
        <i className="mag-glass fa fa-search"></i>
        <i className="fa fa-times-circle" style={{ display : 'none' }}></i>
        <input type="text"
               ref="input"
               className="typeahead form-control full-width"
               id="access-control-search"
               placeholder="search by name, email, group or id"/>
      </div>
    );
  }

}

module.exports = AccessControlSearch;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/manage/access_control_search.jsx